module.exports = __webpack_public_path__ + "img/canoa.efb08263.svg";